import React from "react";
import { Modal, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { accountDelete } from "../service/apis/auth.api";
import { RiDeleteBinLine } from "react-icons/ri";
import { useCustomNavigate } from "../hooks/useCustomNavigate";
import { AppRoute } from "../router/routerConstants";
import { useDispatch } from "react-redux";
import { clearResumeDetails } from "../store/resume.store";
import { clearAllStorage, showError, showSuccess } from "../utils/Common";
import { logOut } from "../store/auth.store";

const AccountDeleteModal = ({ show, onHide }: any) => {
  const [NavigateTo] = useCustomNavigate();
  const dispatch = useDispatch();
  const deleteAccount = async () => {
    try {
      const response = await accountDelete();
       dispatch(logOut());
          clearAllStorage();
          dispatch(clearResumeDetails());
          showSuccess(response?.message);
      NavigateTo(AppRoute.LOGIN);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };
  const handleCancel = () => {
    onHide();
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      className="editPersonalInformation"
      centered
    >
      <Modal.Body>
        <div className="findbody text-center">
          <Form className="logoutmdl">
            <div className="logouticon">
              <RiDeleteBinLine />
            </div>
            <h3>Delete Account</h3>
            <p>Are you sure you want to delete your account?</p>
            <p>
              After deletion, you will no longer be able to access your account
              or recover any information.
            </p>
            <div className="d-flex gp-10">
              <Button className="btn btn-black w-100" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="btn w-100"
              
                onClick={deleteAccount}
              >
                Delete
              </Button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AccountDeleteModal;
